<appKeycodes (onUndo)="undo()" (zoomOut)="zoomOut()" (zoomIn)="zoomIn()" (onBump)="bumpDataflow()"
  (updateMixerView)="updateMixerView($event)" (updateDetailView)="detailViewChange()"
  (onCopySelections)="onCopySelections()" (onPasteSelections)="onPasteSelections()"
  (onDrawModeChange)="drawModeChange($event)" (onExplode)="onExplode()" (onWindowResize)="updateViewAdjustBar()"
  (onPan)="panMixer($event)" (onEditorModeChange)="editorModeChange($event)">
</appKeycodes>





<div class="view-container">

  <div class="header-container">


    <mat-toolbar class="topbar">



      <div class="topbar-button-group">

        <div class="logo"></div>


        <span>AdaCAD </span>


        <div class="sparkle">
          <div class="sparkle-1">✨</div>
          <div class="sparkle-2">✨</div>
          <div class="sparkle-3">✨</div>
          <button matButton="elevated" color="accent" (click)="openNews()">New! version
            {{current_version}}</button>
        </div>


        <button mat-icon-button [matMenuTriggerFor]="file"><i class="fa-solid fa-house"></i></button>


        <!-- to do - add download all  -->

        <mat-menu #file="matMenu">
          <button mat-menu-item (click)="loadBlankFile()">New Workspace</button>
          <button mat-menu-item [disabled]="!connection_state || !user_auth_state" (click)="openAdaFiles('load')">Manage
            Saved Files</button>
          <button mat-menu-item [disabled]="!connection_state" [matMenuTriggerFor]="openFile">Open .Ada
            Workspace</button>
          <button mat-menu-item [disabled]="!connection_state" [matMenuTriggerFor]="importFile">Import Draft(s)</button>
          <app-download origin="menu" [ids]="(vs.showing === -1 ? [] : [vs.showing])"
            [workspaceName]="filename_form.value"></app-download>
          <button mat-menu-item [disabled]="!connection_state || !user_auth_state" (click)="saveFile()">Save</button>
          <button mat-menu-item (click)="openAboutDialog()">About</button>

        </mat-menu>

        <mat-menu #importFile="matMenu">
          <button mat-menu-item (click)="import('bitmap')">...from Bitmap(s)</button>
          <button mat-menu-item (click)="import('wif')">...from .WIF File(s)</button>
        </mat-menu>

        <mat-menu #openFile="matMenu">
          <button mat-menu-item (click)="openNewFileDialog()">From Computer</button>
          <button mat-menu-item [disabled]="!connection_state || !user_auth_state" (click)="openAdaFiles('load')">From
            AdaCAD Cloud
            @if (!user_auth_state) {
            <span>you must login to use this feature </span>
            }
          </button>
        </mat-menu>


        <!-- <button class="fullwidth" mat-icon-button (click)="openMaterials()">
          <i class="fa-solid fa-palette"></i>
        </button> -->







        <button mat-icon-button matTooltip="view/change settings" (click)="openWorkspaceSettings()"><i
            class="fa-solid fa-gear"></i></button>



        <button mat-icon-button matTooltip="get help" [matMenuTriggerFor]="help"><i
            class="fa-solid fa-question"></i></button>
        <mat-menu #help="matMenu">
          <button mat-menu-item (click)="openHelp()">Open Documentation</button>
          <button mat-menu-item (click)="openDiscord()">Ask Questions on Discord</button>
          <button mat-menu-item (click)="openBug()">Report Issue on GitHub</button>
        </mat-menu>


        <button mat-icon-button matTooltip="view examples" (click)="openExamples()"><i
            class="fa-solid fa-lightbulb"></i></button>




      </div>

      <div class="topbar-button-group">
        <span class="design_mode">design mode </span>
        <mat-button-toggle-group name="editingMode" [(ngModel)]="selected_editor_mode" class="toggle"
          aria-label="Editor Style" (change)="toggleEditorMode()">
          @for (mode of editorModes; track mode) {
          <mat-button-toggle [value]="mode.value" [matTooltip]="mode.value"><span
              [class]="mode.icon"></span></mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>



      <div class="topbar-button-group">
        <div class="auth">
          @if (!connection_state) {

          <div mat-stroked-button class="offline">No Internet Connection, Working in Offline Mode</div>
          }

          @if (connection_state && user_auth_state) {

          <button mat-flat-button color="primary" [matMenuTriggerFor]="account"> Hi {{user_auth_name}} <i
              class="fa-solid fa-caret-down"></i> </button>
          <mat-menu #account="matMenu">
            <button mat-menu-item (click)="openAdaFiles('load')">Manage Saved Files</button>
            <button mat-menu-item (click)="logout()">Log Off</button>
          </mat-menu>
          }



          @if (connection_state && !user_auth_state) {

          <button mat-raised-button color="primary" class="example-full-width login" matTooltip="login"
            (click)="openLoginDialog()"><i class="fa fa-sign-in"></i> Log in</button>
          }

        </div>
      </div>

    </mat-toolbar>

  </div>


  <div class="ui-grid">

    <div class="ui-left" [style.width.px]="vas.left">



      <app-library class="library-container" [class.hide]="selected_editor_mode !== 'library'"
        [class.show]="selected_editor_mode === 'library'" #library id="library" cdkScrollable
        (onOpenInEditor)="openInEditor($event)" (onOpenInMixer)="openInMixer($event)"
        (onDraftNameChange)="updateDraftName($event)" (onWorkspaceRename)="renameWorkspaceFromLibrary($event)"
        (onImportCalled)="import($event)">
      </app-library>


      <app-mixer class="mixer-container" [class.hide]="selected_editor_mode !== 'mixer'"
        [class.show]="selected_editor_mode === 'mixer'" #mixer id="mixer" cdkScrollable
        (onOpenInEditor)="openInEditor($event)" (onPerformOperationError)="postOperationErrorMessage($event)">
      </app-mixer>



      <app-editor id="draftdetail" class="detail-container" [class.hide]="selected_editor_mode !== 'editor'"
        [class.show]="selected_editor_mode === 'editor'" (saveChanges)="saveFile()" (cloneDraft)="cloneDraft($event)"
        (createDraft)="createDraft($event)" (updateMixer)="forceRedraw()" (onEditMaterials)="onEditMaterials()"
        (onImportCalled)="import($event)"></app-editor>




    </div>

    <app-viewadjust #viewadjust class="view-adjust-overlay"></app-viewadjust>

    <div class="ui-right" [style.width.px]="vas.right">
      <app-viewer #viewer class="static-container" (onOpenEditor)="openInEditor($event)"
        (onDraftRename)="updateDraftName($event)"></app-viewer>




    </div>


  </div>

  <div class="footer-container">

    <div class="footer-left">

      <button mat-icon-button (click)="zoomToFit()">
        <i class="fa-solid fa-arrows-to-eye"></i>
      </button>

      <button mat-icon-button (click)="zoomOut()"><i class="fas fa-search-minus"></i></button>

      <mat-slider min="0" [max]="zs.num_steps" step="1">
        <input matSliderThumb [formControl]="zoom_form">
      </mat-slider>


      <button mat-icon-button (click)="zoomIn()"><i class="fas fa-search-plus"></i></button>


      <button matButton matTooltip="undo" (click)="undo()">
        <i class="fa-solid fa-rotate-left"></i> {{ss.history.length}}
      </button>



    </div>


    @if(selected_editor_mode === 'mixer') {

    @if (multiselect.selected.length > 0) {
    <div class="copypaste">
      <button mat-raised-button color="primary" (click)="clearSelections()">Deselect</button>
      <button mat-raised-button color="primary" (click)="onCopySelections()"><i class="fa-solid fa-copy"></i>
        copy</button>
      <button mat-raised-button color="primary" [disabled]="multiselect.copy === undefined || multiselect.copy === null"
        (click)="onPasteSelections()"><i class="fa-solid fa-paste"></i> paste</button>
      <button mat-raised-button color="accent" (click)="deleteSelections()"><i class="fa-solid fa-trash"></i>
        delete</button>
    </div>
    }

    @if (multiselect.selected.length == 0) {
    <div class="copypaste">
      hold shift and click to select multiple drafts and operators
    </div>
    }
    }



    <div class="footer-right">
      filename:
      <input class="filename" [formControl]="filename_form" (keyup.enter)="renameWorkspace(filename_form.value)"
        matInput placeholder="current filename">

      @if (filename_form.dirty) {
      <button mat-raised-button color="accent" (click)="renameWorkspace(filename_form.value)">
        Save
      </button>
      }

      <app-download origin="footer" [ids]="(vs.showing === -1 ? [] : [vs.showing])"
        [workspaceName]="filename_form.value"></app-download>
      <button mat-raised-button matTooltip="share" color="primary" (click)="share()">
        <i class="fa-solid fa-share-nodes"></i>
      </button>

    </div>
  </div>
</div>